import styled, {css} from "styled-components";
export const TooltipContainer = styled.div.withConfig({
  displayName: "tooltipstyles__TooltipContainer",
  componentId: "sc-1719ag4-0"
})(["", ""], {
  position: "relative",
  display: "inline-flex"
});
const borderTooltipContent = 3;
function calculatePosition(position, width) {
  switch (position) {
    case "right":
      return css(["top:calc(-0.5rem - ", "px);left:100%;margin-left:0.5rem;"], borderTooltipContent + 2);
    case "left":
      return css(["top:calc(-0.5rem - ", "px);right:100%;margin-right:0.5rem;"], borderTooltipContent);
    case "bottom":
      return css(["top:100%;margin-top:calc(0.5rem - ", "px);left:50%;margin-left:-", "px;"], borderTooltipContent + 2, Math.floor(width / 2 + borderTooltipContent * 2));
    case "top":
    default:
      return css(["bottom:100%;margin-bottom:calc(0.5rem - ", "px);left:50%;margin-left:-", "px;"], borderTooltipContent + 2, Math.floor(width / 2 + borderTooltipContent * 2));
  }
}
function calculateArrowPosition(position, bgColor) {
  switch (position) {
    case "right":
      return css(["top:1.25rem;right:100%;margin-top:-5px;border-color:transparent ", " transparent transparent;"], bgColor);
    case "left":
      return css(["top:1.25rem;left:100%;margin-top:-5px;border-color:transparent transparent transparent ", ";"], bgColor);
    case "bottom":
      return css(["bottom:100%;left:50%;margin-left:-5px;border-color:transparent transparent ", " transparent;"], bgColor);
    case "top":
    default:
      return css(["top:100%;left:50%;margin-left:-5px;border-color:", " transparent transparent transparent;"], bgColor);
  }
}
export const TooltipTextContainer = styled.div.withConfig({
  displayName: "tooltipstyles__TooltipTextContainer",
  componentId: "sc-1719ag4-1"
})(["min-width:", "px;max-width:", "px;color:", ";background-color:", ";font-size:0.9rem;", ";", " &::after{content:' ';border-width:5px;", ";", "}"], ({
  width
}) => width, ({
  width
}) => width, ({
  color
}) => color, ({
  bgColor
}) => bgColor, ({
  position,
  width
}) => calculatePosition(position, width), {
  paddingTop: "0.5rem",
  paddingBottom: "0.5rem",
  paddingLeft: "0.75rem",
  paddingRight: "0.75rem",
  position: "absolute",
  zIndex: "50",
  borderRadius: "0.5rem",
  overflowWrap: "break-word"
}, ({
  position,
  bgColor
}) => calculateArrowPosition(position, bgColor), {
  position: "absolute",
  borderStyle: "solid"
});
